import BaseApi from '../BaseApi';
import axios from 'axios';
import { config } from '@/common/app.config';

class ContactApi extends BaseApi {
  getContacts(params: any) {
    return this.getList(params);
  }

  async exportContacts(params: any) {
    const response = await axios.get(
      `${config.apiUrl}/api/${this.getSpecificApiPrefix()}/export`,
      {
        params: { ...params, lang: (window as any).i18n?.locale },
        responseType: 'blob',
        headers: { timezone: 'UTC+09:00' },
      },
    );
    return response;
  }

  protected getSpecificApiPrefix(): string {
    return 'v2/managers/contacts';
  }
}

export default ContactApi;
